export default "__VITE_ASSET__CMh2yJGT__"